.options-grid{display:grid;grid-template-columns:1fr 1fr}
/*# sourceMappingURL=number-line.component-76SJZIEA.css.map */
